/* =========================================================================
   CO2-Rechner – Berechnungsmodell
   Umsetzung des Tabellenblatts "Eingabe und Berechnung" sowie "Ausgabe"
   aus CO2_Rechner_*.xlsx. Reine Funktionen, im Browser (window.CO2Model)
   und in Node (module.exports) verwendbar.
   Institut für Baustatik und Konstruktion, ETH Zürich
   ========================================================================= */
"use strict";

(function () {

  /* Bauteile der Ausgabe mit Hauptgruppe (HG) und Kategorie (Kat).
     Hinweis: In der Excel-Vorlage sind die Code-Spalten A:B der Ausgabe
     gegenüber den nach Rang sortierten Zeilen verschoben; hier sind die
     Codes den Bauteilen sinngemäss zugeordnet. */
  var COMPONENTS = [
    { key: "roof", name: "Dach", hg: "O", kat: "H" },
    { key: "slabsAbove", name: "Decken über Terrain", hg: "O", kat: "H" },
    { key: "wallsAbove", name: "Wände tragend über Terrain", hg: "O", kat: "V" },
    { key: "colsAbove", name: "Stützen tragend über Terrain", hg: "O", kat: "V" },
    { key: "slabsBelow", name: "Decken unter Terrain", hg: "U", kat: "H" },
    { key: "roofBelow", name: "Dach unter Terrain", hg: "U", kat: "H" },
    { key: "wallsBelow", name: "Wände tragend unter Terrain", hg: "U", kat: "V" },
    { key: "colsBelow", name: "Stützen tragend unter Terrain", hg: "U", kat: "V" },
    { key: "baseSlab", name: "Bodenplatte (ohne Sauberkeitsschicht)", hg: "U", kat: "B" },
    { key: "foundation", name: "Fundation", hg: "F", kat: "B" },
    { key: "pitSupport", name: "Baugrubenverbau", hg: "B", kat: "VO" },
    { key: "excavation", name: "Aushub (ohne Fundationsaushub)", hg: "B", kat: "VO" }
  ];

  var MAIN_GROUPS = [
    { key: "O", name: "Obergeschosse" },
    { key: "U", name: "Untergeschosse inkl. BP" },
    { key: "F", name: "Fundation" },
    { key: "B", name: "Baugrube und Aushub" }
  ];

  var CATEGORIES = [
    { key: "H", name: "Horizontale Bauteile" },
    { key: "V", name: "Vertikale Bauteile" },
    { key: "B", name: "Bodenplatte und Fundation" },
    { key: "VO", name: "Aushub und Baugrubenverbau" }
  ];

  /* Bestand/Reuse: Anteil in %, der wiederverwendet wird und daher nicht
     neu anfällt. Jede Eingabe gilt für die genannten Teilsummen (parts) des
     Bauteils; ohne parts für das ganze Bauteil. Baugrubenverbau und
     Aushub fallen immer neu an. */
  var RC = ["Beton", "Bewehrung"];
  var REUSE = [
    { comp: "roof", key: "roofReuse", label: "Dach" },
    { comp: "slabsAbove", key: "slabAboveReuse", label: "Decken" },
    { comp: "slabsBelow", key: "slabBelowReuse", label: "Stahlbeton", parts: RC },
    { comp: "roofBelow", key: "roofBelowReuse", label: "Stahlbeton", parts: RC },
    { comp: "roofBelow", key: "roofBelowSealReuse", label: "Abdichtung", parts: ["Abdichtung"] },
    { comp: "wallsAbove", key: "wallAboveReuse", label: "Betonwände", parts: ["Betonwände"] },
    { comp: "wallsAbove", key: "wallAboveMasonryReuse", label: "Mauerwerkswände", parts: ["Mauerwerkswände"] },
    { comp: "wallsAbove", key: "wallAboveStudReuse", label: "Holzständerwände", parts: ["Holzständerwände"] },
    { comp: "wallsBelow", key: "wallBelowReuse", label: "Stahlbeton", parts: RC },
    { comp: "wallsBelow", key: "wallBelowInsReuse", label: "Dämmung/Abdichtung", parts: ["Dämmung", "Abdichtung"] },
    { comp: "colsAbove", key: "colAboveConReuse", label: "Betonstützen", parts: ["Betonstützen"] },
    { comp: "colsAbove", key: "colAboveSteelReuse", label: "Stahlstützen", parts: ["Stahlstützen"] },
    { comp: "colsAbove", key: "colAboveTimberReuse", label: "Holzstützen", parts: ["Holzstützen"] },
    { comp: "colsBelow", key: "colBelowConReuse", label: "Betonstützen", parts: ["Betonstützen"] },
    { comp: "colsBelow", key: "colBelowSteelReuse", label: "Stahlstützen", parts: ["Stahlstützen"] },
    { comp: "colsBelow", key: "colBelowTimberReuse", label: "Holzstützen", parts: ["Holzstützen"] },
    { comp: "baseSlab", key: "baseReuse", label: "Stahlbeton", parts: RC },
    { comp: "baseSlab", key: "baseInsReuse", label: "Dämmung/Abdichtung", parts: ["Dämmung", "Abdichtung"] },
    { comp: "foundation", key: "padReuse", label: "Einzelfundamente", parts: ["Einzelfundamente"] },
    { comp: "foundation", key: "stripReuse", label: "Streifenfundamente", parts: ["Streifenfundamente"] },
    { comp: "foundation", key: "pileReuse", label: "Bohrpfähle", parts: ["Bohrpfähle"] }
  ];

  /* Auswahlwert für ein eigenes Material; dessen GWP steht im Feld
     <Schlüssel>Gwp, in der Bezugseinheit der jeweiligen Liste */
  var CUSTOM = "Benutzerdefiniert";

  /* Kostenansätze: Preise pro Bezugseinheit, für alle Varianten gemeinsam.
     Beton, Bewehrung und Holz nach Vorschlag Johanna (Kostentabelle
     Deckenrechner), Lieferpreise. Die übrigen sind grobe Richtwerte für die
     Schweiz (Stand 2026): Material als Lieferpreis wie oben; Erdarbeiten,
     Verbau und Pfähle ausgeführt, abgestimmt auf die Standardwahl der Vorlage.
     basis: Grundlage des Standardwerts, wird bei der Eingabe angezeigt. */
  var COST_ITEMS = [
    { key: "concrete", name: "Beton", unit: "m³", def: 200, basis: "Transportbeton, Lieferung" },
    { key: "rebar", name: "Bewehrungsstahl", unit: "kg", def: 2, basis: "Lieferung" },
    { key: "glulam", name: "Brettschichtholz", unit: "m³", def: 1350, basis: "Lieferung" },
    { key: "timber", name: "Vollholz", unit: "m³", def: 1350, basis: "Lieferung" },
    { key: "masonry", name: "Mauerwerk", unit: "m³", def: 300, basis: "Kalksandstein/Backstein inkl. Mörtel, Lieferung" },
    { key: "studWall", name: "Holzständerwand", unit: "m²", def: 120, basis: "Ständer, Beplankung, Dämmung, Lieferung" },
    { key: "steel", name: "Stahlprofile", unit: "kg", def: 3, basis: "zugeschnitten, mit Kopf- und Fussplatten" },
    { key: "insulation", name: "Dämmung", unit: "m³", def: 300, basis: "XPS-Platten, Lieferung" },
    { key: "sealing", name: "Abdichtung", unit: "m²", def: 25, basis: "Polymerbitumenbahn zweilagig, Lieferung" },
    { key: "piles", name: "Bohrpfähle", unit: "m", def: 250, basis: "Mikrobohrpfahl, ausgeführt" },
    { key: "pitSupport", name: "Baugrubenverbau", unit: "m²", def: 300, basis: "Rühlwand gespriesst, ausgeführt" },
    { key: "excavation", name: "Aushub", unit: "m³", def: 50, basis: "maschinell, inkl. Abfuhr und Deponie" }
  ];

  /* Holz aus Lamellen, Brettern oder Furnier wird als Brettschichtholz
     gerechnet, alles übrige (auch benutzerdefiniert) als Vollholz */
  function timberCostItem(name) {
    return /schichtholz|sperrholz|Brettstapel/i.test(name) ? "glulam" : "timber";
  }

  function num(v) {
    var n = typeof v === "number" ? v : parseFloat(v);
    return isFinite(n) ? n : 0;
  }

  function div(a, b) {
    return b ? a / b : NaN;
  }

  /* prices: Kostenansätze je COST_ITEMS-Schlüssel; ohne Angabe die Standardwerte */
  function calc(inp, db, prices) {
    var x = {};
    Object.keys(inp).forEach(function (k) {
      x[k] = typeof inp[k] === "string" || typeof inp[k] === "boolean" ? inp[k] : num(inp[k]);
    });

    function mat(name) {
      var m = db.materials[name];
      return {
        density: m && m.density !== null ? m.density : 0,
        gwp: m && m.gwp !== null ? m.gwp : 0
      };
    }

    function profile(name) {
      for (var i = 0; i < db.profiles.length; i++) if (db.profiles[i].name === name) return db.profiles[i].kgPerM;
      return 0;
    }

    function custom(k) {
      return x[k] === CUSTOM ? num(x[k + "Gwp"]) : null;
    }

    function stud(k) {
      if (custom(k) !== null) return custom(k);
      for (var i = 0; i < db.studWalls.length; i++) if (db.studWalls[i].name === x[k]) return db.studWalls[i].gwpM2;
      return 0;
    }

    /* GWP pro Bezugseinheit der Datenbank (kg, m, m² bzw. m³) */
    function gwp(k) {
      return custom(k) !== null ? custom(k) : mat(x[k]).gwp;
    }

    /* GWP pro m³ = GWP pro kg · Rohdichte */
    function gwpM3(k) {
      if (custom(k) !== null) return custom(k);
      var m = mat(x[k]);
      return m.gwp * m.density;
    }

    function step(label, value, unit) {
      return { label: label, value: value, unit: unit };
    }

    /* Stahlbetonbauteil: Beton + Bewehrung aus Volumen und Bewehrungsgehalt */
    function rc(vol, concrete, rebar, rho) {
      var kgCon = vol * gwpM3(concrete);
      var massReb = vol * rho;
      var kgReb = massReb * gwp(rebar);
      return { vol: vol, kgCon: kgCon, massReb: massReb, kgReb: kgReb, kg: kgCon + kgReb };
    }

    /* Menge für die Kosten: part wie in den Teilsummen (für Bestand/Reuse),
       item aus COST_ITEMS; price nur für Ansätze, die je Variante eingegeben werden */
    function cq(part, item, qty, price) {
      var q = { part: part, item: item, qty: qty };
      if (price !== undefined) q.price = price;
      return q;
    }

    function rcQty(part, res, partReb) {
      return [cq(part, "concrete", res.vol), cq(partReb || part, "rebar", res.massReb)];
    }

    var r = {};

    /* --- Decken und Dach ------------------------------------------------ */
    var areaOg = x.ogL * x.ogB;
    var areaUg = x.ugL * x.ugB;

    r.roof = {
      kg: areaOg * x.roofGwpM2,
      steps: [step("Dachfläche", areaOg, "m²")],
      qty: [cq(null, "slab", areaOg, x.roofCostM2)]
    };

    r.slabsAbove = {
      kg: areaOg * x.ogN * x.slabAboveGwpM2,
      steps: [step("Deckenfläche über Terrain", areaOg * x.ogN, "m²")],
      qty: [cq(null, "slab", areaOg * x.ogN, x.slabAboveCostM2)]
    };

    var vSlabBelow = areaUg * x.slabBelowT * x.ugN;
    var slabBelow = rc(vSlabBelow, "slabBelowConcrete", "slabBelowRebar", x.slabBelowRho);
    r.slabsBelow = {
      kg: slabBelow.kg,
      parts: [{ label: "Beton", kg: slabBelow.kgCon }, { label: "Bewehrung", kg: slabBelow.kgReb }],
      steps: [
        step("Volumen Beton gesamt", vSlabBelow, "m³"),
        step("GWP Beton", gwpM3("slabBelowConcrete"), "kg CO₂-eq/m³"),
        step("Masse Bewehrung", slabBelow.massReb, "kg"),
        step("GWP pro Deckenfläche", div(slabBelow.kg, areaUg * x.ugN), "kg CO₂-eq/m²")
      ],
      qty: rcQty("Beton", slabBelow, "Bewehrung")
    };

    /* Ragt das Untergeschoss über das Obergeschoss hinaus, entsteht ein
       Dach unter Terrain; im umgekehrten Fall wird die Differenz der
       Bodenplatte zugeschlagen. */
    var areaDiff = areaUg - areaOg;
    var roofBelowArea = areaDiff < 0 ? 0 : areaDiff;
    var baseExtraArea = areaDiff > 0 ? 0 : -areaDiff;
    var vRoofBelow = roofBelowArea * x.roofBelowT;
    var roofBelow = rc(vRoofBelow, "roofBelowConcrete", "roofBelowRebar", x.roofBelowRho);
    var vRoofSeal = x.roofBelowSealMm / 1000 * roofBelowArea;
    var kgRoofSeal = vRoofSeal * gwpM3("roofBelowSeal");
    r.roofBelow = {
      kg: roofBelow.kg + kgRoofSeal,
      parts: [
        { label: "Beton", kg: roofBelow.kgCon },
        { label: "Bewehrung", kg: roofBelow.kgReb },
        { label: "Abdichtung", kg: kgRoofSeal }
      ],
      steps: [
        step("Dachfläche unter Terrain", roofBelowArea, "m²"),
        step("Volumen Beton gesamt", vRoofBelow, "m³"),
        step("Masse Bewehrung", roofBelow.massReb, "kg"),
        step("Volumen Abdichtung", vRoofSeal, "m³")
      ],
      qty: rcQty("Beton", roofBelow, "Bewehrung").concat([cq("Abdichtung", "sealing", x.roofBelowSealMm ? roofBelowArea : 0)])
    };

    /* --- Wände ---------------------------------------------------------- */
    var vWallAboveG = x.wallAboveT * x.ogH * x.wallAboveLen;
    var vWallAbove = vWallAboveG * x.ogN;
    var wallAboveCon = rc(vWallAbove, "wallAboveConcrete", "wallAboveRebar", x.wallAboveRho);
    var vMasonry = x.wallAboveMasonryLen * x.ogH * x.wallAboveMasonryT * x.ogN;
    var kgMasonry = vMasonry * gwpM3("wallAboveMasonry");
    var aStud = x.wallAboveStudLen * x.ogH * x.ogN;
    var kgStud = aStud * stud("wallAboveStud");
    r.wallsAbove = {
      kg: wallAboveCon.kg + kgMasonry + kgStud,
      parts: [
        { label: "Betonwände", kg: wallAboveCon.kg },
        { label: "Mauerwerkswände", kg: kgMasonry },
        { label: "Holzständerwände", kg: kgStud }
      ],
      steps: [
        step("Volumen Beton pro Geschoss", vWallAboveG, "m³"),
        step("Volumen Beton gesamt", vWallAbove, "m³"),
        step("Masse Bewehrung", wallAboveCon.massReb, "kg"),
        step("Volumen Mauerwerk gesamt", vMasonry, "m³"),
        step("Fläche Holzständer gesamt", aStud, "m²")
      ],
      qty: rcQty("Betonwände", wallAboveCon).concat([
        cq("Mauerwerkswände", "masonry", vMasonry),
        cq("Holzständerwände", "studWall", aStud)
      ])
    };

    var perimUg = 2 * (x.ugL + x.ugB);
    /* Versatz +: Die Decke über dem obersten Untergeschoss ragt über das
       Terrain hinaus; dieser Teil der Untergeschosse liegt nicht im Erdreich,
       braucht keine Abdichtung, und Baugrube und Aushub werden weniger tief.
       Versatz −: Die Decke liegt tiefer als das Terrain; Baugrube und Aushub
       werden tiefer, Dämmung und Abdichtung reichen um den Versatz über die
       Untergeschosse hinaus (gerechnet mit dem Umfang der Untergeschosse). */
    var ugHeight = x.ugH * x.ugN;
    var ugOffset = Math.min(Math.max(-x.ogH * x.ogN, x.ugOffset), ugHeight);
    var vWallBelowG = x.wallBelowT * x.ugH * perimUg + x.ugH * x.wallBelowInnerLen * x.wallBelowT;
    var vWallBelow = vWallBelowG * x.ugN;
    var wallBelowCon = rc(vWallBelow, "wallBelowConcrete", "wallBelowRebar", x.wallBelowRho);
    var aWallBelowOuter = (ugHeight + Math.max(0, -ugOffset)) * perimUg;
    var aWallBelowSeal = (ugHeight - ugOffset) * perimUg;
    var vWallIns = x.wallBelowInsT * aWallBelowOuter;
    var kgWallIns = vWallIns * gwpM3("wallBelowIns");
    var vWallSeal = x.wallBelowSealMm / 1000 * aWallBelowSeal;
    var kgWallSeal = vWallSeal * gwpM3("wallBelowSeal");
    r.wallsBelow = {
      kg: wallBelowCon.kg + kgWallIns + kgWallSeal,
      parts: [
        { label: "Beton", kg: wallBelowCon.kgCon },
        { label: "Bewehrung", kg: wallBelowCon.kgReb },
        { label: "Dämmung", kg: kgWallIns },
        { label: "Abdichtung", kg: kgWallSeal }
      ],
      steps: [
        step("Volumen Beton pro Geschoss", vWallBelowG, "m³"),
        step("Volumen Beton gesamt", vWallBelow, "m³"),
        step("Masse Bewehrung", wallBelowCon.massReb, "kg"),
        step("Fläche Dämmung", aWallBelowOuter, "m²"),
        step("Fläche Abdichtung im Erdreich", aWallBelowSeal, "m²"),
        step("Volumen Dämmung", vWallIns, "m³"),
        step("Volumen Abdichtung", vWallSeal, "m³")
      ],
      qty: rcQty("Beton", wallBelowCon, "Bewehrung").concat([
        cq("Dämmung", "insulation", vWallIns),
        cq("Abdichtung", "sealing", x.wallBelowSealMm ? aWallBelowSeal : 0)
      ])
    };

    /* --- Stützen -------------------------------------------------------- */
    function columns(pre, h, n) {
      var vConG = x[pre + "ConB"] * x[pre + "ConL"] * h * x[pre + "ConN"];
      var con = rc(vConG * n, pre + "Concrete", pre + "Rebar", x[pre + "Rho"]);
      var massSteelG = profile(x[pre + "SteelProfile"]) * h * x[pre + "SteelN"];
      var kgSteel = n * massSteelG * mat(db.steelProfileMaterial).gwp;
      var vTimber = x[pre + "TimberB"] * x[pre + "TimberN"] * x[pre + "TimberL"] * h * n;
      var kgTimber = vTimber * gwpM3(pre + "Timber");
      return {
        kg: con.kg + kgSteel + kgTimber,
        parts: [
          { label: "Betonstützen", kg: con.kg },
          { label: "Stahlstützen", kg: kgSteel },
          { label: "Holzstützen", kg: kgTimber }
        ],
        steps: [
          step("Volumen Beton gesamt", vConG * n, "m³"),
          step("Masse Bewehrung", con.massReb, "kg"),
          step("Masse Stahlprofile gesamt", massSteelG * n, "kg"),
          step("Volumen Holz gesamt", vTimber, "m³")
        ],
        qty: rcQty("Betonstützen", con).concat([
          cq("Stahlstützen", "steel", massSteelG * n),
          cq("Holzstützen", timberCostItem(x[pre + "Timber"]), vTimber)
        ])
      };
    }
    r.colsAbove = columns("colAbove", x.ogH, x.ogN);
    r.colsBelow = columns("colBelow", x.ugH, x.ugN);

    /* --- Bodenplatte ---------------------------------------------------- */
    var vBase = (areaUg + baseExtraArea) * x.baseT;
    var base = rc(vBase, "baseConcrete", "baseRebar", x.baseRho);
    var vBaseIns = areaUg * x.baseInsT;
    var kgBaseIns = vBaseIns * gwpM3("baseIns");
    var vBaseSeal = x.baseSealMm / 1000 * areaUg;
    var kgBaseSeal = vBaseSeal * gwpM3("baseSeal");
    r.baseSlab = {
      kg: base.kg + kgBaseIns + kgBaseSeal,
      parts: [
        { label: "Beton", kg: base.kgCon },
        { label: "Bewehrung", kg: base.kgReb },
        { label: "Dämmung", kg: kgBaseIns },
        { label: "Abdichtung", kg: kgBaseSeal }
      ],
      steps: [
        step("Fläche Bodenplatte", areaUg + baseExtraArea, "m²"),
        step("Volumen Beton gesamt", vBase, "m³"),
        step("Masse Bewehrung", base.massReb, "kg"),
        step("Volumen Dämmung", vBaseIns, "m³"),
        step("Volumen Abdichtung", vBaseSeal, "m³")
      ],
      qty: rcQty("Beton", base, "Bewehrung").concat([
        cq("Dämmung", "insulation", vBaseIns),
        cq("Abdichtung", "sealing", x.baseSealMm ? areaUg : 0)
      ])
    };

    /* --- Fundation ------------------------------------------------------ */
    var vPads = x.padL * x.padB * x.padD * x.padN;
    var pads = rc(vPads, "fndConcrete", "fndRebar", x.padRho);
    var vStrips = x.stripB * x.stripD * x.stripLen;
    var strips = rc(vStrips, "fndConcrete", "fndRebar", x.stripRho);
    var lenPiles = x.pileLen * x.pileN;
    var kgPiles = lenPiles * gwp("pileType");
    r.foundation = {
      kg: pads.kg + strips.kg + kgPiles,
      parts: [
        { label: "Einzelfundamente", kg: pads.kg },
        { label: "Streifenfundamente", kg: strips.kg },
        { label: "Bohrpfähle", kg: kgPiles }
      ],
      steps: [
        step("Volumen Einzelfundamente", vPads, "m³"),
        step("Volumen Streifenfundamente", vStrips, "m³"),
        step("Masse Bewehrung", pads.massReb + strips.massReb, "kg"),
        step("Gesamtlänge Bohrpfähle", lenPiles, "m")
      ],
      qty: rcQty("Einzelfundamente", pads).concat(rcQty("Streifenfundamente", strips), [cq("Bohrpfähle", "piles", lenPiles)])
    };

    /* --- Baugrube und Aushub ------------------------------------------- */
    var trench = x.pitTrenchW;
    var offset = (trench + x.wallBelowInsT) * 2;
    var pitArea = (x.ugL + offset) * (x.ugB + offset);
    var pitPerim = (x.ugL + trench * 2) * 2 + (x.ugB + trench * 2) * 2;
    /* Tiefe ab OK Terrain bis Unterkante Dämmung unter der Bodenplatte */
    var pitDepth = ugHeight - ugOffset + x.baseT + x.baseInsT;
    var pitWall = pitPerim * pitDepth;
    r.pitSupport = {
      kg: x.pitPresent ? pitWall * gwp("pitType") : 0,
      steps: [
        step("Umfang", pitPerim, "m"),
        step("Tiefe Verbau", pitDepth, "m"),
        step("Fläche Verbau", pitWall, "m²")
      ],
      qty: [cq(null, "pitSupport", x.pitPresent ? pitWall : 0)]
    };

    var vExc = pitArea * pitDepth;
    r.excavation = {
      kg: vExc * gwp("excavationType"),
      steps: [
        step("Grundfläche", pitArea, "m²"),
        step("Tiefe", pitDepth, "m"),
        step("Volumen", vExc, "m³")
      ],
      qty: [cq(null, "excavation", vExc)]
    };

    /* --- Kosten (brutto) ---------------------------------------------- */
    var priceOf = {};
    COST_ITEMS.forEach(function (it) {
      priceOf[it.key] = prices && prices.hasOwnProperty(it.key) ? prices[it.key] : it.def;
    });
    COMPONENTS.forEach(function (c) {
      var comp = r[c.key], cost = { gross: 0, lines: [], missing: [], reuse: 0 };
      comp.qty.forEach(function (q) {
        if (!(q.qty > 0)) return;
        var p = q.hasOwnProperty("price") ? q.price : priceOf[q.item];
        p = typeof p === "number" && p > 0 ? p : null;
        var chf = p === null ? 0 : q.qty * p;
        if (p === null && cost.missing.indexOf(q.item) === -1) cost.missing.push(q.item);
        cost.lines.push({ part: q.part, item: q.item, qty: q.qty, price: p, chf: chf });
        cost.gross += chf;
      });
      cost.chf = cost.gross;
      comp.cost = cost;
    });

    /* --- Bestand/Reuse ------------------------------------------------- */
    /* Der wiederverwendete Anteil wird von der Bauteilsumme abgezogen;
       Teilsummen (parts) und Zwischenwerte bleiben brutto. */
    COMPONENTS.forEach(function (c) {
      r[c.key].gross = r[c.key].kg;
      r[c.key].reuse = [];
      r[c.key].reuseKg = 0;
    });
    REUSE.forEach(function (e) {
      var pct = Math.min(100, Math.max(0, num(inp[e.key])));
      if (!pct) return;
      var c = r[e.comp], base = c.gross;
      if (e.parts) {
        base = 0;
        c.parts.forEach(function (p) { if (e.parts.indexOf(p.label) !== -1) base += p.kg; });
      }
      var kg = base * pct / 100;
      c.reuse.push({ label: e.label, pct: pct, kg: kg });
      c.reuseKg += kg;
      c.kg -= kg;
      /* Wiederverwendetes Material muss auch nicht neu gekauft werden */
      var chf = 0;
      c.cost.lines.forEach(function (l) { if (!e.parts || e.parts.indexOf(l.part) !== -1) chf += l.chf; });
      c.cost.reuse += chf * pct / 100;
      c.cost.chf -= chf * pct / 100;
    });

    /* --- Ausgabe -------------------------------------------------------- */
    var total = 0;
    COMPONENTS.forEach(function (c) { total += r[c.key].kg; });
    var reuseKg = 0;
    COMPONENTS.forEach(function (c) { reuseKg += r[c.key].reuseKg; });

    function sumBy(field, groups) {
      var out = {};
      groups.forEach(function (g) { out[g.key] = 0; });
      COMPONENTS.forEach(function (c) { out[c[field]] += r[c.key].kg; });
      return out;
    }

    var areaAbove = areaOg * x.ogN;

    /* Kosten je Kostenansatz (brutto, vor Bestand/Reuse) und gesamt (netto) */
    var costTotal = 0, costMissing = [], byItem = {};
    COMPONENTS.forEach(function (c) {
      var cost = r[c.key].cost;
      costTotal += cost.chf;
      cost.missing.forEach(function (k) { if (costMissing.indexOf(k) === -1) costMissing.push(k); });
      cost.lines.forEach(function (l) {
        var b = byItem[l.item] = byItem[l.item] || { qty: 0, chf: 0 };
        b.qty += l.qty;
        b.chf += l.chf;
      });
    });

    var epf = div(div(total, x.ebf), x.lifespan);

    return {
      components: r,
      total: total,
      mainGroups: sumBy("hg", MAIN_GROUPS),
      categories: sumBy("kat", CATEGORIES),
      eval: {
        perStoreyAbove: div(total, x.ogN),
        perStorey: div(total, x.ogN + x.ugN),
        areaAbove: areaAbove,
        perArea: div(total, areaAbove),
        ebf: x.ebf,
        lifespan: x.lifespan,
        epf: epf,
        target: x.target,
        reuseKg: reuseKg
      },
      costs: {
        total: costTotal,
        missing: costMissing,
        byItem: byItem
      },
      equivalents: {
        flights: div(total, db.comparisons.flight),
        carOrbits: div(total, db.comparisons.carOrbit),
        personYears: div(total, db.comparisons.personYear)
      }
    };
  }

  var api = {
    COMPONENTS: COMPONENTS,
    MAIN_GROUPS: MAIN_GROUPS,
    CATEGORIES: CATEGORIES,
    REUSE: REUSE,
    CUSTOM: CUSTOM,
    COST_ITEMS: COST_ITEMS,
    calc: calc
  };

  if (typeof module !== "undefined" && module.exports) module.exports = api;
  else window.CO2Model = api;
})();
